import React, { useCallback, useMemo, useState } from 'react'
import {
  Box,
  Container,
  FormControlLabel,
  Switch,
  Typography,
  makeStyles
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import OperationalTable, { useOperationalTable } from '../../../organisms/OperationalTable'
import { useSearchRegistrations } from '../../../../api/registrations'
import { defaultColumnConfig, buildSearchBody, getDetailPath } from './helpers'

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '1rem',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '1.75rem'
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '1rem',
    paddingBottom: '1rem'
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: 600
  },
  superHeader: {
    paddingTop: '0.5rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  controls: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center'
  }
}))

function RegistrationsView () {
  const classes = useStyles()
  const history = useHistory()
  const {
    defaultPageSize,
    pageIndex,
    pageSize,
    sort,
    searchText,
    onPagingChange,
    onSortingChange,
    onSearchTextChange,
    onTableModeChange
  } = useOperationalTable(defaultColumnConfig)

  const [activeOnly, setActiveOnly] = useState(false)

  const searchBody = useMemo(() => buildSearchBody({
    pageIndex,
    pageSize,
    sort,
    searchText,
    activeOnly
  }), [pageIndex, pageSize, sort, searchText, activeOnly])

  const { data: result, isFetching } = useSearchRegistrations(searchBody)

  const rows = result?.data ?? []
  const total = result?.total ?? 0

  const onClickRow = useCallback((row) => {
    if (row.original) {
      history.push(getDetailPath(row.original))
    }
  }, [history])

  const onToggleActive = useCallback((event) => {
    setActiveOnly(event.target.checked)
  }, [])

  return (
    <Container maxWidth={false} className={classes.container}>
      <Box className={classes.header}>
        <Typography className={classes.title}>Registrations</Typography>
      </Box>
      <OperationalTable.Wrapper>
        <OperationalTable.SuperHeader className={classes.superHeader}>
          <OperationalTable.Search
            onChange={onSearchTextChange}
            placeholder='Search by name (last, long, or first)'
            delay={250}
          />
          <Box className={classes.controls}>
            <FormControlLabel
              control={
                <Switch
                  checked={activeOnly}
                  onChange={onToggleActive}
                  color='primary'
                />
              }
              label='Active only'
            />
          </Box>
        </OperationalTable.SuperHeader>
        <OperationalTable
          mode='server'
          columns={defaultColumnConfig.columns}
          data={rows}
          defaultPageSize={defaultPageSize}
          defaultSort={defaultColumnConfig.defaultSort}
          itemName='Registrations'
          loading={isFetching}
          total={total}
          searchText={searchText}
          onSortingChange={onSortingChange}
          onPagingChange={onPagingChange}
          onTableModeChange={onTableModeChange}
          onRowClick={onClickRow}
        />
      </OperationalTable.Wrapper>
    </Container>
  )
}

export default RegistrationsView
